import { definePreset, palette } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const brokerColors = {
    white: '#ffffff',
    offwhite: '#fff7f1',
    gray: '#eeeeee',
    beige: '#d3c0aa',
    orange: '#edb78c',
    orange2: '#d88c63',
    orange3: '#d38540',
    blue: '#38788b',
    green: '#2f4142',
};

const brokerPalettes = {
    white: palette(brokerColors.white),
    offwhite: palette(brokerColors.offwhite),
    gray: palette(brokerColors.gray),
    beige: palette(brokerColors.beige),
    orange: palette(brokerColors.orange),
    orange2: palette(brokerColors.orange2),
    orange3: palette(brokerColors.orange3),
    blue: palette(brokerColors.blue),
    green: palette(brokerColors.green),
};

const lightPrimaryPalette = brokerPalettes.orange2;
const darkPrimaryPalette = brokerPalettes.orange2;
const lightSurfacePalette = brokerPalettes.green;
const darkSurfacePalette = brokerPalettes.blue;

export const Broker = definePreset(Aura, {
    semantic: {
        colorScheme: {
            light: {
                primary: {
                    50: lightPrimaryPalette[50],
                    100: lightPrimaryPalette[100],
                    200: lightPrimaryPalette[200],
                    300: lightPrimaryPalette[300],
                    400: lightPrimaryPalette[400],
                    500: lightPrimaryPalette[500],
                    600: lightPrimaryPalette[600],
                    700: lightPrimaryPalette[700],
                    800: lightPrimaryPalette[800],
                    900: lightPrimaryPalette[900],
                    950: lightPrimaryPalette[950],
                },
                surface: {
                    50: lightSurfacePalette[50],
                    100: lightSurfacePalette[100],
                    200: lightSurfacePalette[200],
                    300: lightSurfacePalette[300],
                    400: lightSurfacePalette[400],
                    500: lightSurfacePalette[500],
                    600: lightSurfacePalette[600],
                    700: lightSurfacePalette[700],
                    800: lightSurfacePalette[800],
                    900: lightSurfacePalette[900],
                    950: lightSurfacePalette[950],
                },
            },
            dark: {
                primary: {
                    50: darkPrimaryPalette[50],
                    100: darkPrimaryPalette[100],
                    200: darkPrimaryPalette[200],
                    300: darkPrimaryPalette[300],
                    400: darkPrimaryPalette[400],
                    500: darkPrimaryPalette[500],
                    600: darkPrimaryPalette[600],
                    700: darkPrimaryPalette[700],
                    800: darkPrimaryPalette[800],
                    900: darkPrimaryPalette[900],
                    950: darkPrimaryPalette[950],
                },
                surface: {
                    50: darkSurfacePalette[50],
                    100: darkSurfacePalette[100],
                    200: darkSurfacePalette[200],
                    300: darkSurfacePalette[300],
                    400: darkSurfacePalette[400],
                    500: darkSurfacePalette[500],
                    600: darkSurfacePalette[600],
                    700: darkSurfacePalette[700],
                    800: darkSurfacePalette[800],
                    900: darkSurfacePalette[900],
                    950: darkSurfacePalette[950],
                },
            },
        },
    },
});
